
import { defineComponent } from "vue";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import store from "@/store";

export default defineComponent({
  components: {
    CatalogueGrid,
  },
  props: {
    parentModel: { required: true },
    parentEditingConfig: { required: false, type: TableEditingConfig },
    selectMode: { required: false, type: Boolean, default: false },
  },
  computed: {
    loadedPackages() {
      return (store.state as any).loadedPackages.loadedPackages;
    }
  },
  watch: {
    loadedPackages(newVal) {
      if (newVal)
        this.highlightedSchemes = Object.keys(newVal);
      else
        this.highlightedSchemes = null;
      this.$refs.grid.dxGrid.refresh();
    }
  },
  methods: {
    onContentReady(e: any) {
      this.$emit("content-ready", e);
    },
    onSelectionChanged(e: any) {
      this.$emit("selection-changed", e);
    },
    onRowPrepared(e: any) {
      var data = e.data;
      if (data && this.parentModel) {
        if (data.packagesVolume >= this.parentModel.loadStatThreshold) {
          e.rowElement.bgColor = "#E5FFF0";
        } else {
          e.rowElement.bgColor = "#FFE5E5";
        }
      }
      if (data && this.highlightedSchemes) {
        if (this.highlightedSchemes.includes(data.id.toString()))
          e.rowElement.classList.add("highlightedScheme");
      }
    },
  },
  data() {
    return {
      highlightedSchemes: null,
      columns: [
        new TextColumnConfig({
          dataField: "number",
          caption: "Номер схемы",
          readOnly: true,
        }),
        new IntegerColumnConfig({
          dataField: "packagesVolume",
          caption: "Объем (м³)",
          min: 0,
        }),
        new IntegerColumnConfig({
          dataField: "containerCount",
          caption: "Количество контейнеров (шт)",
          min: 0,
        }),
      ],
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        hoverStateEnabled: true,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        horizontalScroll: false,
      }),
      editingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        allowDeleteAll: false,
        confirmDelete: true,
        allowDataFill: false,
        allowExport: false,
        allowClearFilter: false,
        allowDeleteMultipleRows: false,
        mode: "row",
      }),
      pageSizes: [10, 20, 50, 100],
    };
  },
  created() {
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
  },
});
